import { render, staticRenderFns } from "./ImportImage.vue?vue&type=template&id=97b1c244&scoped=true"
import script from "./ImportImage.vue?vue&type=script&lang=js"
export * from "./ImportImage.vue?vue&type=script&lang=js"
import style0 from "./ImportImage.vue?vue&type=style&index=0&id=97b1c244&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b1c244",
  null
  
)

export default component.exports